import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    AvatarModule,
    ButtonModule,
    CheckboxModule,
    DialogConfig,
    DialogRef,
    InputModule,
    SelectModule
} from '@sag-ui';
import { SharedModule } from '../../../shared/shared.module';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ICreateUser, IEntraIdUser, IUser, Roles } from '@cod-monorepo/interfaces';
import { catchError, debounceTime, filter, of, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { UserManagementService } from '../../services/user-management.service';

@Component({
    selector: 'app-add-user-dialog',
    standalone: true,
    imports: [
        CommonModule,
        ButtonModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        InputModule,
        SelectModule,
        AvatarModule,
        CheckboxModule
    ],
    templateUrl: './add-user.component.html'
})
export class AddUserDialogComponent implements OnInit, OnDestroy {
    public formGroup = new FormGroup({
        gid: new FormControl('', Validators.required),
        gidValid: new FormControl(false, Validators.requiredTrue),
        roles: new FormControl<Roles[]>([], Validators.required)
    });
    public roles = Roles;
    public results: IEntraIdUser[] = [];
    public selectedIndex: number | null = null;
    public selectedUser: IEntraIdUser | null = null;
    public noUserFound = false;
    private destroy$ = new Subject<void>();

    constructor(
        private userService: UserManagementService,
        public config: DialogConfig<IUser>,
        public dialogRef: DialogRef<ICreateUser>
    ) {}

    ngOnInit(): void {
        this.fetchUser();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public onClose(confirm: boolean): void {
        if (!confirm || !this.selectedUser) {
            this.dialogRef.close();
            return;
        }

        this.dialogRef.close({
            country: this.selectedUser.country,
            firstName: this.selectedUser.firstName,
            lastName: this.selectedUser.surName,
            email: this.selectedUser.mail,
            gid: this.selectedUser.gid,
            // TODO: managerGid: this.result.managerGid,
            roles: this.formGroup.get('roles')?.value ?? []
        });
    }

    public get invalid(): boolean {
        return this.formGroup.invalid;
    }

    public selectResult(index: number): void {
        this.selectedIndex = index;
        this.selectedUser = this.results[index];
    }

    private async fetchUser(): Promise<void> {
        this.formGroup.controls.gid.valueChanges
            .pipe(
                takeUntil(this.destroy$),
                debounceTime(500),
                filter(value => !!value),
                // GID validation
                filter(value => /^[Z|X][A-Z0-9]{7}$/.test((value as string).toUpperCase())),
                tap(() => {
                    this.noUserFound = false;
                    this.formGroup.controls.gidValid.setValue(false);
                }),
                switchMap(value =>
                    this.userService.getUsersFromEntraId({ gid: value as string }).pipe(
                        catchError(() => {
                            this.results = [];
                            this.formGroup.controls.gidValid.setValue(false);
                            this.noUserFound = true;
                            return of([]);
                        })
                    )
                ),
                tap(result => {
                    this.results = result;
                    this.formGroup.controls.gidValid.setValue(result.length > 0);
                    this.noUserFound = result.length === 0;
                })
            )
            .subscribe();
    }
}
